import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import styled, { keyframes } from "styled-components";
import { SG_CREATE_DEBRIEF_PDF_REPORT } from "constants/actions";
import { getReportLink } from "../../utils";
import Filters from "app/audit/simple/Filters";

const LongFormRequest = ({
  calculatedData,
  prevDataCalculated,
  anchorName,
  orgName,
  get_auth,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const createReport = () => {
    const tracking_code = uuidv4();

    const report = {
      template_id: 12,
      organization: Number(get_auth?.organization_id),
      employee: Number(get_auth?.employee_id),
      tracking_code,
      params: {
        data: {
          calculatedData,
          prevDataCalculated,
          anchorName,
          orgName,
        },
        report_link: getReportLink(12),
      },
    };

    dispatch({
      type: SG_CREATE_DEBRIEF_PDF_REPORT,
      payload: report,
    });

    navigate("/leader/audit/reports");
  };

  return (
    <Container>
      <Section>
        <T1>Select the report filters (Optional)</T1>
        <Description>
          When you're ready, click the "Generate Report" button.
        </Description>
        <Filters />
      </Section>
    </Container>
  );
};

export default LongFormRequest;

/** Styled Components & Animations **/
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div`
  font-family: "Raleway";
  animation: ${fadeIn} 1s ease-out;
`;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  font-family: "Raleway";
  color: #2a3039;
  line-height: 1.5;
  margin-top: 20px;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  letter-spacing: -0.35px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const Description = styled.div`
  font-size: 16px;
  color: #2a3039;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const GenerateButton = styled.button`
  background-color: #2d70e2;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1b59c1;
  }
`;
